import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './HintPanel.css';

/**
 * Reusable hint display panel for all games
 * @param {boolean} isOpen - Whether the hint panel is visible
 * @param {Function} onClose - Callback when closing the hint panel
 * @param {Array<string>} hints - Array of all hints for the puzzle
 * @param {number} revealedCount - Number of hints already revealed
 * @param {Function} onRevealNext - Callback when user wants to reveal next hint
 */
function HintPanel({ isOpen, onClose, hints = [], revealedCount = 0, onRevealNext }) {
  const hasMoreHints = revealedCount < hints.length;

  console.log('💡 HintPanel render:', { isOpen, hintsLength: hints.length, revealedCount, hasMoreHints });

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="hint-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <motion.div
            className="hint-panel"
            initial={{ x: -400, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -400, opacity: 0 }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          >
            <div className="hint-header">
              <h3>💡 Hints</h3>
              <button className="hint-close-btn" onClick={onClose}>
                ✕
              </button>
            </div>

            <div className="hint-content">
              {hints.length === 0 ? (
                <p className="no-hints">No hints available for this puzzle.</p>
              ) : (
                <>
                  <div className="hints-list">
                    {hints.slice(0, revealedCount).map((hint, index) => (
                      <motion.div
                        key={index}
                        className="hint-item"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                      >
                        <div className="hint-number">Hint {index + 1}</div>
                        <div className="hint-text">{hint}</div>
                      </motion.div>
                    ))}
                  </div>

                  {hasMoreHints && (
                    <motion.button
                      className="reveal-btn"
                      onClick={() => {
                        console.log('💡 Reveal Next Hint clicked. Current count:', revealedCount);
                        onRevealNext();
                      }}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      Reveal Next Hint ({revealedCount}/{hints.length})
                    </motion.button>
                  )}

                  {!hasMoreHints && hints.length > 0 && (
                    <div className="all-hints-shown">
                      All hints revealed! You've got this! 🎯
                    </div>
                  )}
                </>
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}

export default HintPanel;
